// extracted by mini-css-extract-plugin
module.exports = {"lia-card-membership-badge":"MembershipTypeForNode_lia-card-membership-badge__FZCoe"};